import { Injectable } from '@angular/core';
import { ICommunicationEvent } from '../ICommunicationEvent';
import { PlatformCommunicationEvents } from '@shared/generalInterfaces';
import { take } from 'rxjs';
import { Router } from '@angular/router';
import { LogoutService } from '../../../services/authentication/logout.service';

@Injectable({ providedIn: 'root' })
export class TokenExpired implements ICommunicationEvent {
	constructor(
		private logoutService: LogoutService,
		private router: Router
	) {}

	get eventName(): string {
		return PlatformCommunicationEvents.TokenExpired;
	}

	async handleEvent(event: any) {
		this.logoutService.logout(String(event.data.sessionId), { returnUrl: this.router.url }).pipe(take(1)).subscribe();
	}
}
